import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import { IoHomeOutline } from 'react-icons/io5';
import { FaLaptopCode } from 'react-icons/fa';
import { CgWebsite } from 'react-icons/cg';
import { MdOutlinePersonSearch } from 'react-icons/md';
import TemporaryDrawer from '../Drawer';
import './Header.css'; // Assuming you have a CSS file for header styles

const links = [
  { text: 'Home', path: '/', icon: <IoHomeOutline /> },
  { text: 'Projects', path: '/projects', icon: <CgWebsite /> },
  { text: 'Skills', path: '/skills', icon: <FaLaptopCode /> },
  { text: 'About', path: '/about', icon: <MdOutlinePersonSearch /> },
];

export const Header = () => {
  const [activeTab, setActiveTab] = useState('/');

  const handleTabClick = (path) => {
    setActiveTab(path);
  };

  return (
    <nav className='list-container'>
      <div className='nav-icons-container'>
        <TemporaryDrawer />
        <div className='drawer'>
          <p className='description'>Balu Surya Portfolio</p></div>
        <div className='nav-container'>
          {links.map((link) => (
            <div className={`link ${link.path === activeTab ? 'active sections-container' : 'sections-container'}`}
            key={link.text}>
              <NavLink
                to={link.path}
                className='link'
                onClick={() => handleTabClick(link.path)}
              >
                {link.text}
              </NavLink>
              {link.icon}
            </div>
          ))}
        </div>
      </div>
    </nav>
  );
};
